export enum NavigationMenuPositionerCssVars {
  /**
   * The available width between the trigger and the edge of the viewport.
   * @type {number}
   */
  availableWidth = '--available-width',
  /**
   * The available height between the trigger and the edge of the viewport.
   * @type {number}
   */
  availableHeight = '--available-height',
  /**
   * The anchor's width.
   * @type {number}
   */
  anchorWidth = '--anchor-width',
  /**
   * The anchor's height.
   * @type {number}
   */
  anchorHeight = '--anchor-height',
  /**
   * The coordinates that this element is anchored to. Used for animations and transitions.
   * @type {string}
   */
  transformOrigin = '--transform-origin',
  /**
   * The fixed width of the positioner element.
   * @type {number}
   */
  positionerWidth = '--positioner-width',
  /**
   * The fixed height of the positioner element.
   * @type {number}
   */
  positionerHeight = '--positioner-height',
}
